exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-12a2c133] {\n  position: relative;\n}\n.search .far[data-v-12a2c133] {\n  position: absolute;\n  right: 0.25em;\n  top: calc(50% - .5em);\n  font-size: 1.3rem;\n  color: #adb5bd;\n}", ""]);

// exports
